import { Text, Flex } from '@/app/ui';
import { translate } from '@/app/i18n';

const HelpPage = () => (
  <Flex.Container flexDirection="column" gap="3rem" padding="3rem">
    <Flex.Container>
      <Text.Title2>{translate('HELP_PAGE.WELCOME_TO_SOLORIGHTS')}</Text.Title2>
    </Flex.Container>

    <Flex.Container flexDirection="column" gap="1rem" style={{ maxWidth: 800, margin: '0 auto' }}>
      <Flex.Item>
        <Text.Paragraph>{translate('HELP_PAGE.WELCOME_TO_SOLORIGHTS_DESCRIPTION')}</Text.Paragraph>
      </Flex.Item>
      <Flex.Item>
        <Text.Paragraph>
          {translate('HELP_PAGE.WELCOME_TO_SOLORIGHTS_DESCRIPTION_2')}
        </Text.Paragraph>
      </Flex.Item>
      <Flex.Item>
        <Text.Paragraph>
          {translate('HELP_PAGE.WELCOME_TO_SOLORIGHTS_DESCRIPTION_3')}{' '}
          <Text.Span color="#8d00ff">info@solorights.online</Text.Span>.
        </Text.Paragraph>
      </Flex.Item>
      <Flex.Item>
        <Text.Paragraph>
          {translate('HELP_PAGE.WELCOME_TO_SOLORIGHTS_DESCRIPTION_4')}
        </Text.Paragraph>
      </Flex.Item>
    </Flex.Container>
  </Flex.Container>
);

export default HelpPage;
